const Attribution = () => {
  return <div className="attribution">저작권</div>;
};

export default Attribution;
